<div class="modal-header">
    <h4>{{ modalMode }} Instance User</h4>
    <a class="close-icon" href="javascript:void()" ngbAutofocus><i class="flaticon2-cross" (click)="closeAddUSerModal()"></i></a>
</div>
<div class="modal-body output-lable new-user">
    <div class="row">
        <div class="col-md-12" style="padding: 15px">
            <div class="email-wrapper">
                <mat-label class="font-style">Email</mat-label>
                <mat-form-field class="search_field custom-text-field" [floatLabel]="'never'">
                    <input matInput type="email" placeholder="Enter email" [(ngModel)]="instanceuser.email" readonly />
                </mat-form-field>
                <!-- <button type="button" class="validate_button btn primary-ebtn" (click)="validateUser()" [disabled]="editUserForm.get('user_email').hasError('email')">Validate</button> -->
            </div>
            <div class="name-wrapper">
                <div class="input-names-wrapper">
                    <mat-label class="font-style">First Name</mat-label>
                    <mat-form-field class="custom-text-field" [floatLabel]="'never'">
                        <input matInput type="text" placeholder="Enter first name" [(ngModel)]="instanceuser.firstName" readonly />
                    </mat-form-field>
                </div>
                <div class="input-names-wrapper">
                    <mat-label class="font-style">Last Name</mat-label>
                    <mat-form-field class="custom-text-field" [floatLabel]="'never'">
                        <input matInput type="text" placeholder="Enter last name" [(ngModel)]="instanceuser.lastName" readonly />
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn secondary-ebtn" (click)="closeAddUSerModal()">Cancel</button>
</div>
